/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderAuthOptions } from './FxIdApplicationPublicDataBuilderAuthOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderAuthOptions,
    FxIdApplicationPublicDataBuilderAuthOptionsFromJSON,
    FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderAuthOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderAuthOptions';

/**
 * @type FxIdWebFeaturesPlayGameResponseAuth
 * 
 * @export
 */
export type FxIdWebFeaturesPlayGameResponseAuth = FxIdApplicationPublicDataBuilderAuthOptions;

export function FxIdWebFeaturesPlayGameResponseAuthFromJSON(json: any): FxIdWebFeaturesPlayGameResponseAuth {
    return FxIdWebFeaturesPlayGameResponseAuthFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameResponseAuth {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(json)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesPlayGameResponseAuthToJSON(json: any): any {
    return FxIdWebFeaturesPlayGameResponseAuthToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseAuthToJSONTyped(value?: FxIdWebFeaturesPlayGameResponseAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderAuthOptions(value)) {
        return FxIdApplicationPublicDataBuilderAuthOptionsToJSON(value as FxIdApplicationPublicDataBuilderAuthOptions);
    }

    return {};
}

